var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29862 6.35294C7.29862 5.97392 7.61264 5.66667 8 5.66667C8.38736 5.66667 8.70138 5.97392 8.70138 6.35294V9.09804C8.70138 9.47706 8.38736 9.78431 8 9.78431C7.61264 9.78431 7.29862 9.47706 7.29862 9.09804V6.35294Z",
    fill: "#959595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.6078C7.61264 10.6078 7.29862 10.9151 7.29862 11.2941C7.29862 11.6731 7.61264 11.9804 8 11.9804C8.38736 11.9804 8.70138 11.6731 8.70138 11.2941C8.70138 10.9151 8.38736 10.6078 8 10.6078Z",
    fill: "#959595"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.687 11.6347L15.6909 11.6413C16.5797 13.1572 15.44 15 13.6959 15H2.30409C0.55996 15 -0.579705 13.1573 0.309121 11.6413L0.312992 11.6347L6.01406 2.11608C6.21679 1.775 6.50726 1.49374 6.85451 1.2987C7.2037 1.10257 7.59883 1 8 1C8.40117 1 8.7963 1.10257 9.14549 1.2987C9.49277 1.49376 9.78326 1.77505 9.98599 2.11615L15.687 11.6347ZM8.53178 2.94574L14.2308 12.4609C14.4644 12.8593 14.1693 13.3529 13.6959 13.3529H2.30409C1.83071 13.3529 1.53562 12.8593 1.76923 12.4609L7.46822 2.94574C7.52176 2.85502 7.59915 2.7796 7.69254 2.72714C7.78593 2.67469 7.89201 2.64706 8 2.64706C8.108 2.64706 8.21407 2.67469 8.30746 2.72714C8.40086 2.7796 8.47825 2.85502 8.53178 2.94574Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.74616664e2606c352394c9128e93314d.svg";
export { ForwardRef as ReactComponent };